import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { GallerySection } from './components/GallerySection';
import { ValueSection } from './components/ValueSection';
import { ServiceAreasSection } from './components/ServiceAreasSection';
import { ServicesSection } from './components/ServicesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { WhyEithanSection } from './components/WhyEithanSection';
import { VisionSection } from './components/VisionSection';
import { CTASection } from './components/CTASection';
import { OneLinersSection } from './components/OneLinersSection';
import { Footer } from './components/Footer';
import { FloatingMessageButton } from './components/FloatingMessageButton';
import { WavyDivider } from './components/SectionDivider';
export function App() {
  return <div className="min-h-screen bg-brand-black font-sans text-white selection:bg-brand-gold/20 selection:text-brand-gold" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <div id="inicio" data-id="element-3">
          <HeroSection data-id="element-4" />
        </div>
        <IntroSection data-id="element-5" />
        <div id="galeria" data-id="element-6">
          <GallerySection data-id="element-7" />
        </div>
        <ValueSection data-id="element-8" />
        <div id="areas" data-id="element-9">
          <ServiceAreasSection data-id="element-10" />
        </div>
        <div id="servicios" data-id="element-11">
          <ServicesSection data-id="element-12" />
        </div>
        <div id="testimonios" data-id="element-13">
          <TestimonialsSection data-id="element-14" />
        </div>
        <WhyEithanSection data-id="element-15" />
        <VisionSection data-id="element-16" />
        <div id="contacto" data-id="element-17">
          <CTASection data-id="element-18" />
        </div>
        <OneLinersSection data-id="element-19" />
      </main>
      <Footer data-id="element-20" />
      <FloatingMessageButton data-id="element-21" />
    </div>;
}